export default "__VITE_ASSET__Bs026r$j__"